import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getJacksonvilleStructuredData() {
  const url = "https://restorehair.com/locations/florida/jacksonville/";
  const description =
    "Find out about your hair transplant options in Jacksonville with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("jacksonville", url, description),
    locationPageCrumbs(url, "Jacksonville"),
  ];
}
